import instanceJWT from "./apiJwt";
import type { OnboardingQuestItem } from "../models/onboarding/OnboardingTypes";

interface ApiResponse<T> {
  status: boolean;
  error: boolean;
  data: T;
}

interface ChecklistResponseData {
  items: OnboardingQuestItem[];
}

/**
 * Чек-лист квестов онбординга. Бэкенд ЛК проксирует запрос в сервис `onboarding`,
 * подставляя profileId/clientId текущей сессии — сам сервис `onboarding` не
 * аутентифицирован и не должен вызываться из браузера напрямую.
 */
export async function getOnboardingChecklist(): Promise<OnboardingQuestItem[]> {
  const response = await instanceJWT.get<ApiResponse<ChecklistResponseData>>("onboarding/checklist");
  return response.data.data?.items ?? [];
}
